// import Report from '@/views/report'
import Rank from '@/views/rank';
import Xinfa from '@/views/record/xinfa';
import GameWords from '@/views/record/game-words';


export default [
  {
    path: 'rank',
    name: 'rank',
    component: Rank,
  },
  {
    path: 'xinfa',
    name: 'xinfa',
    component: Xinfa,
  },
  {
    path: 'game-words',
    name: 'gameWords',
    component: GameWords,
  },
  {
    path: 'audio-player',
    name: 'audioPlayer',
    component: () => import('@/views/record/audio-player/index.vue'),
  },
  // {
  //   path: 'report',
  //   name: 'report',
  //   component: Report,
  // },
]
